import React from 'react'
import classNames from 'classnames'

import ItemCard from '../itemCard'

const ListDefault = ({
  items,
  viewType,
  currentSite,
  itemDecorator,
  videoMuted,
  muteVideo,
  isSqueezed
}) => {
  const rootClassName = classNames('product-list', {
    'product-list--squeezed': isSqueezed,
    'product-list--big-preview': currentSite === 'themeforest'
  })
  return (
    <ul data-test-selector="list-layout" className={rootClassName}>
      {items.map((item, index) => {
        return (
          <li key={item.id}>
            <ItemCard
              currentSite={currentSite}
              viewType={viewType}
              itemProps={itemDecorator(item, index)}
              videoMuted={videoMuted}
              muteVideo={muteVideo}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default ListDefault
